import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstStudyTeamTeamViewModalComponent } from './ist-study-team-team-view-modal/ist-study-team-team-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstStudyTeamOrganizationViewModalComponent } from '../ist-study-team-organization/ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import * as $ from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-ist-study-team-team',
  templateUrl: './ist-study-team-team.component.html',
  styleUrls: ['./ist-study-team-team.component.scss']
})
export class IstStudyTeamTeamComponent implements OnInit {

  columnDefs;
  tempoperations;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  UserRoleList: any[];
  ApplicationID: string;
  studyTeamAdaceSearch: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.permission = "";
    if (this.commonService.getPagePermission("IST02") != null && this.commonService.getPagePermission("IST02") != undefined) {
      this.permission = this.commonService.getPagePermission("IST02").toLowerCase();
    }
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, {  });
      modalRef.componentInstance.Content= { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Study Team', operation: { hasConfirm: false } } }
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }
    this.userType = this.userService.getUserType();
    this.studyTeamAdaceSearch = new UntypedFormGroup({
      FirstNAME: new UntypedFormControl(null),
      OrganizationName: new UntypedFormControl(null),
      UserRole: new UntypedFormControl(null),
      Occupation: new UntypedFormControl(null),
      EmailID: new UntypedFormControl(null, [Validators.email]),
      PhoneNumber: new UntypedFormControl(null, [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(20)])
    });



    this.setMasterData();
    this.columnDefs = [
      {
        "headerName": "Full Name",
        "field": "FirstNAME"
      },
      {
        "headerName": "Organization Name",
        "field": "OrganizationName"
      },
      {
        "headerName": "Occupation",
        "field": "Occupation"
      },
      {
        "headerName": "Email ID",
        "field": "EmailID"
      },
      {
        "headerName": "Phone number",
        "field": "PhoneNumber"
      }
    ];


    this.advanceSearch =
    {
      "fields": [
        {
          "label": "First Name",
          "field": "FirstName",
          "type": "text"
        },
        {
          "label": "Organisation Name",
          "field": "OrganizationName",
          "type": "text"
        },
        {
          "label": "User Role",
          "field": "UserRole",
          "type": "dropdown",
          "options": this.UserRoleList,
        },
        {
          "label": "Occupation",
          "field": "Occupation",
          "type": "text"
        },
        {
          "label": "Email",
          "field": "EmailID",
          "type": "text"
        },
        {
          "label": "Phone number",
          "field": "PhoneNumber",
          "type": "text"
        }
      ]
    }
    this.setSummary();
  }

  onSetGridApi(gridApi) {
   
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.datashareService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const ModelRef= this.modalService.open(IstStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg modal-full-height modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add_open_form() {
    this['self'].router.navigate(['/home/ist/applications/application-ext/:1/study_team_team_request/study_team_team_request/:1'], { skipLocationChange: true })
  }

  add(service, datashareService1) {
    var emptyList = [];
    datashareService1.setIstMemberOrgList(emptyList);
    let modalRef = this['self'].modalService.open(IstStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  edit() {
    let modalRef = this['self'].modalService.open(IstStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }
  view() {
    let modalRef = this["self"].modalService.open(IstStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }
  delete(summaryService,) {
    let id = this['self'].selectedRow['ID'];
    let Name = this['self'].selectedRow['FirstNAME'];
    if (this['self'].selectedRow["CREATED_BY"] != "Admin") {

      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false
      })
      modalRef.componentInstance.Content= { heading: 'Delete', custommessage: 'The Team member ' + Name + ' will be deleted. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "No" }
      modalRef.result.then(result => {
        if (result == "okclick") {
          summaryService.DeleteRecord('api/ISTStudyTeam/Delete?RecordID=' + id).subscribe(summary => {
            ;
            if (summary["Status"] == 0) {
              this['self'].commonService.SuccessBanner(summary["Message"]);
              this['self'].setSummary();
            }
            else {
              this.commonService.ValidationBanner(summary["Message"]);
            }
          });
        }
      });

    }
    else {
      this.commonService.ValidationBanner("Default Record can't be Deleted");
    }
  }

  add_org() {
    let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: '', ApplicationID: this.ApplicationID }
    }
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    return this.operations;
  }


  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "View",
        "id": "view"
      },
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];
    if (this.permission == "new") {
      tempoperations.push({
        "name": "Add New",
        "id": "add"
      });
    }

    let tempoperations2 = [
      {
        "name": "View",
        "id": "view"
      }
    ];
    if (this.permission == "new") {
      tempoperations2.push({
        "name": "Add Member",
        "id": "add"
      });

      tempoperations2.push({
        "name": "Edit",
        "id": "edit"
      });
    }

    if (this.permission == "edit") {     

      tempoperations2.push({
        "name": "Edit",
        "id": "edit"
      });
    }


    RawData.forEach(element => {
      if (element.CREATED_BY == "Admin" || this.permission == "view") {

        element["Operations"] = this.setDef(tempoperations2);
      }
      else {

        element["Operations"] = this.setDef(tempoperations);
      }
    });
    return RawData;
  }

  getSearchData(formData) {
    this.summaryService.fetchSearchData("api/ISTStudyTeam/GetSummarySearchData", formData).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }
  setSummary() {
    this.SearchClear();
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getSummaryData("api/ISTStudyTeam/GetSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
        this.rowData = this.setOperations(summary);
      });
    }
    else {
      this.rowData = [];
    }

  }
  setMasterData() {
    this.summaryService.masterData("api/ISTStudyTeam/GetMasterDataSearch?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.UserRoleList = summary["MasterData2"];
      this.UserRoleList = [{ label: "Select", value: "", checked: true }].concat(this.UserRoleList);
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.studyTeamAdaceSearch.reset();
    //  this.setSummary();
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

  validEmail(event: any) {
   // const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (this.commonService.validateEmail(event.value)) {
      $("#EMAIL").addClass("ng-untouched ng-valid");
      $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
    }
    else {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      var message = "please enter valid Email ID<br/>";
      this.commonService.ValidationBanner(message);
     // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    }
  }

  ValidateForm() {
    var err: any = [];
    if (this.studyTeamAdaceSearch.valid) {
      if (
        !this.studyTeamAdaceSearch.controls["FirstNAME"].value &&
        !this.studyTeamAdaceSearch.controls["OrganizationName"].value &&
        !this.studyTeamAdaceSearch.controls["UserRole"].value &&
        !this.studyTeamAdaceSearch.controls["Occupation"].value &&
        !this.studyTeamAdaceSearch.controls["EmailID"].value &&
        !this.studyTeamAdaceSearch.controls["PhoneNumber"].value
      ) {
        err.push("Please enter at least one criteria to perform search");
        this.commonService.ValidationBanner(err)
        //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
        return false;
      }
    }
    return true;
  }

  AdvanceSearch() {
    if (this.ValidateForm()) {
      var formData = this.studyTeamAdaceSearch.value;
      formData["ApplicationID"] = this.ApplicationID;
      this.getSearchData(formData);
    }
  }


  onAdvanceSearchOperation(searchFiletrs) {

  }
}
